"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = formatInternationalPhoneNumber;
var _isString = _interopRequireDefault(require("lodash/isString"));
var _restrictInput = require("./restrictInput");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function formatInternationalPhoneNumber() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  if (!(0, _isString["default"])(value)) {
    return '';
  }
  var parsedValue = (0, _restrictInput.numbersSpacesDashesBracketsOnly)(value);
  parsedValue = parsedValue.replace(/^0+/, '0').replace(/^[^\d|(]/, '').replace(/\(\)/g, '').replace(/(\()(\D)/g, '$1').replace(/(\D)(\))/g, '$1').replace(/(\))(-)/g, '$1').replace(/(-)(\D)/g, '$1').replace(/(\D)(-)/g, '$1').replace(/\s+/g, ' ');
  return parsedValue;
}